import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { ConversationInterface } from "../../../Entity/Entities/Conversation/ConversationInterface";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import Conversation from "../../Partials/Conversation/Conversation";
import EntityLaunchpanel from "../../Partials/Launchpanel/EntityLaunchpanel";
import * as uuidV4 from "uuid/v4";
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

class ConversationUpdate extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_CONVERSATION_UPDATE_CLEAR;
  protected person: PersonInterface;
  protected middlewares: MiddlewareInterface[] = [
    PreventPageLeave
  ];

  public state = {
    isSaving: false,
    isCreateIncidentPreprocessPopupOpen: false,
    nextPath: "",
    tasks: [],
  }

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    this.fetchTasks()
  }
  public componentWillUnmount() {
    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public createIncident = () => {
    const id = parseInt(this.props.params.id, 10);
    const conversation: ConversationInterface = this.props.app.conversations.find(conversation => conversation?.id === id);
    const task: any = {
      content: {
        name: conversation?.messages?.[0]?.message
      },
      reacted: false,
      amazonFolderName: uuidV4(),
      reporterId: conversation?.contactId,
      eventTypeId: 35, // TODO fix hardcoded value
      conversationId: conversation?.id,
      unitId: conversation?.unitId
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_CREATE_START,
        payload: {
          ...task
        },
        onSuccess: (task: EventInterface) => {
          this.setState({
            nextPath: `/app/task/update/${task.id}`
          }, this.redirectBack)
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    });
  }

  public fetchTasks = () => {
    const id = parseInt(this.props.params.id, 10);

    const conversation: ConversationInterface = this.props.app.conversations.find(conversation => conversation?.id === id);

    const payload: any = {
      eventTypeIds: [35, 38], // task || incident
      removed: 0,
    };

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payload,
        removed: 0,
      },
      onSuccess: (data) => {
        // const tasksArr: EventInterface[] = !!this.state.tasks ?
        //                                         [...this.state.tasks, ...data.events] : [...data.events];

        const tasksArr: EventInterface[] = [...data.events].filter(task => task.conversationId === conversation?.id);
        this.setState({
          tasks: tasksArr,
        });
      }
    });

  }

  public render() {
    const id = parseInt(this.props.params.id, 10);
    const conversation: ConversationInterface = this.props.app.conversations.find(conversation => conversation?.id === id);
    const tasks = this.state.tasks
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("label-conversation")}</h1>
              <div className="button-container-small">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.redirectBack}
                >
                  {this.trans("label-done")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-task-update">
            <div className="component-wrapper no-margin-top no-shadow">
              <div className="component">
                <Card className="card">
                  {
                    <div className="read-only-wrapper" style={{ paddingTop: "32px" }}>
                      <div style={{ color: "gray", fontSize: "14px", marginRight: "5px" }}>
                        {this.trans("page/conversationupdate-hint/relatedto", { entity: conversation?.object?.nameOfEntity })}
                      </div>
                      <div className="margin-wrapper">
                        <div className="link-to-entity" onClick={() => this.redirect(`/app/${conversation?.object?.nameOfEntity === "Activity" ? conversation?.object?.nameOfEntity.toLowerCase() : conversation?.object?.nameForUrl}/update/${conversation?.object?.id}`)}>
                          {conversation?.object?.displayName}
                        </div>
                      </div>
                    </div>
                  }

                  {tasks?.length > 0 &&
                    tasks.map(task => (
                      <div className="read-only-wrapper" style={{ paddingTop: "0" }}>
                        <div style={{ color: "gray", fontSize: "14px", marginRight: "5px" }}>
                          {`${this.trans("task")}:`}
                        </div>
                        <div className="margin-wrapper">
                          <div className="link-to-entity" onClick={() => this.redirect(`/app/task/update/${task?.id}`)}>
                            {task?.displayName}
                          </div>
                        </div>
                      </div>
                    ))

                  }
                </Card>
              </div>
            </div>
            <div className="component-wrapper no-shadow">
              <Conversation
                {...this.props}
                conversation={conversation}
              />
            </div>
          </div>
            <div className={"right-panel-wrapper"}>
              <EntityLaunchpanel
                {...this.props}
                entityTitle={this.trans("launchpanel-conversation-title")}
                actionsList={
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      key={`create-incident-btn`}
                      onClick={() => this.setState({ isCreateIncidentPreprocessPopupOpen: true })}
                      style={{ padding: "1px 16px" }}
                    >
                      <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-task"></div></ListItemIcon>
                      <ListItemText>{this.trans("new-task-based-on-conversation")}</ListItemText>
                    </ListItem>
                  </List>
                }
              />
            </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("launch-panel-create-incident")}
          content={this.trans("preprocess/createincidentfromconversation-hint")}
          prioritizeClosing={true}
          openLeavePrompt={this.state.isCreateIncidentPreprocessPopupOpen}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-continue")}
          onDiscard={() => this.setState({ isCreateIncidentPreprocessPopupOpen: false })}
          onSave={() => this.setState({ isCreateIncidentPreprocessPopupOpen: false }, this.createIncident)}
          hideCross={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    units: state.units,
    events: state.events,
    component: state.conversationUpdate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  ConversationUpdate
);
